<template>
    <div>
        <h5 v-if="filter.title" v-text="filter.title" class="filter-title mb-1" />
        <date-inputs
            :id="fKey"
            :key="filter.value"
            :placeholder="filter.text"
            :val="filter.value"
            :name="fKey"
            :lock-past-days="filter.lockPastDays"
            :lock-future-days="filter.lockFutureDays"
            :lock-range-days-number="filter.lockRangeDaysNumber"
            @change="$emit('set-filter', $event)"
        />
    </div>
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>